import React from "react";

// Geometry traced from the canonical app icon (moonscape-app-icon.svg), normalized to 46 wide.
const DOTS: Array<[number, number]> = [
  [3.72, 3.44], [3.72, 12.94], [3.72, 22.21], [3.72, 31.63],
  [13.32, 5.66],
  [22.94, 8.38], [22.94, 17.72], [22.94, 27.62],
  [32.6, 5.66],
  [42.28, 3.44], [42.28, 12.94], [42.28, 22.21], [42.28, 31.63],
];

/** The dot-matrix Moonscape mark. Brand green in both themes. */
export const Logo = ({
  width = 22,
  color = "#57AB30",
  className,
}: {
  width?: number;
  color?: string;
  className?: string;
}) => (
  <svg
    viewBox="0 0 46 35.1"
    width={width}
    height={Math.round((width * 35.1) / 46)}
    className={className}
    style={{ flex: "none" }}
    aria-hidden="true"
  >
    <g fill={color}>
      {DOTS.map(([cx, cy]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="3.6" />
      ))}
    </g>
  </svg>
);
